import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTodos: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTodos"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H15V20H9V21H3V3ZM16.1839 9.00233L14.9523 8.14607L11.0972 13.6911L8.93302 11.7845L7.94146 12.91L11.3682 15.9289L16.1839 9.00233Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTodos;
